import { Trans, useLingui } from '@lingui/react/macro';
import { Button } from '@repo/videa-components/src/index';

import { InfoBanner } from '@/common-components/elements/InfoBanner/InfoBanner';

export const ConnectionErrorBanner = () => {
  const { t } = useLingui();

  return (
    <div className="vai-mb-6">
      <InfoBanner
        title={t`Unable to connect`}
        description={t`Please verify your credentials and make sure they are correctly entered here and in the payer portal. If the problem persists, please contact customer support so we can help you get set up.`}
        variant="error"
        footer={
          <Button
            variant="link"
            size="sm"
            className="!vai-p-0 vai-text-red-600"
            onClick={() => {
              window.location.href = 'mailto:support@videa.ai';
            }}
          >
            <Trans>Contact customer support →</Trans>
          </Button>
        }
      />
    </div>
  );
};
